import React from 'react';
import { Link } from 'react-router-dom';

export const AssignedEmailRow = ({ email: e }) => (
  <div className="bg-white border border-[#E5E7EB] rounded-lg p-3 flex items-center justify-between gap-3 flex-wrap" data-testid={`inbox-assigned-${e._id}`}>
    <div className="flex-1 min-w-0">
      <p className="font-ibm text-sm text-[#09090B] truncate">{e.subject || '(no subject)'}</p>
      <p className="text-xs text-[#6B7280] font-ibm truncate">From: {e.from} · {new Date(e.received_at).toLocaleString()}</p>
    </div>
    {e.assigned_case_id && (
      <Link to={`/cases/${e.assigned_case_id}`} className="text-xs font-ibm font-semibold text-[#002FA7] hover:underline">Open case →</Link>
    )}
  </div>
);
